export class AppError extends Error {}
